import $ from "jquery";

$(document).on("click", '[data-js="jsLimitLinesTrigger"]', function () {
  const $parent = $(this).closest('[data-js="jsLimitLines"]');
  const isExpanding = !$parent.hasClass("is-expanded");
  $parent.toggleClass("is-expanded");
  $parent
    .find('[data-js="jsLimitLinesMore"]')
    .attr("aria-hidden", !isExpanding)
    .attr("hidden", isExpanding);
  $parent
    .find('[data-js="jsLimitLinesLess"]')
    .attr("aria-hidden", isExpanding)
    .attr("hidden", !isExpanding);
});
